<template>
  <v-flex
    v-if="family !== null"
    xs12
    class="my-5 formatted-text"
  >
    <v-layout
      align-center
      class="mb-3"
    >
      <BaseIcon>
        <HeartIcon :icon-color="isCurrentEdition ? '#ED1C24' : '#8a8a8a'" />
      </BaseIcon>
      <h2 class="display-3 ml-3">
        {{ $t('sheet.sheet_two.special_gifts.title') }}
      </h2>
    </v-layout>
    <v-layout
      class="mb-5"
      wrap
      :ml-5="!hasNotes"
    >
      <v-flex
        v-if="hasNotes"
        md4
        xs12
        pl-5
      >
        <p class="fw-600 mb-1">
          {{ $t('preview.family_needs.notes') | addColons }}
        </p>
        <p class="mb-3">
          {{ family.formattedNeeds.specialGifts.giftsNotes }}
        </p>
      </v-flex>
      <v-flex
        v-bind="flexAttrs"
        xs12
      >
        <v-layout wrap>
          <v-flex
            v-for="(item, index) in family.formattedNeeds.specialGifts.members"
            :key="index"
            xs12
          >
            <v-checkbox
              disabled
              class="mt-0 pt-0 mb-2"
            >
              <template slot="label">
                <p class="mb-0 f-16">
                  <span class="fw-600">{{ item.newName | addColons }}</span> {{ item.gift }}
                </p>
              </template>
            </v-checkbox>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div class="mt-2 f-05">
      <p class="fw-600 mb-0">
        {{ $t('preview.family_needs.notes_justification') | addColons }}
      </p>
      <p class="mb-0">
        {{ $t('preview.family_needs.notes_justification_text') }}
      </p>
    </div>
    <div class="mt-5 pa-3 bordered__red">
      <h2 class="display-3">
        {{ $t('preview.important_needs_title') }}
      </h2>
      <v-checkbox
        v-for="(need, index) in family.formattedNeeds.importantNeeds.list"
        :key="index"
        disabled
        class="mt-3 pt-0 mb-0 ml-4"
        :label="need.need"
      />
    </div>
  </v-flex>
</template>

<script>
import BaseIcon from '@/icons/BaseIcon';
import HeartIcon from '@/icons/HeartIcon';

import filters from '@/constants/filters';
import has from 'lodash.has';

export default {
    name: 'FamilySpecialGifts',
    components: { BaseIcon, HeartIcon },
    filters: {
        ...filters
    },
    computed: {
        family () {
            return this.$store.getters['previewForDonor/getPreviewInfo'];
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        hasNotes () {
            const specialGiftNotes = has(this.family?.formattedNeeds?.specialGifts, 'giftsNotes');
            return specialGiftNotes;
        },
        flexAttrs () {
            return this.hasNotes ? { md8: true } : { xs12: true };
        }
    }
};
</script>

<style scoped></style>
